/** Extrae key S3 desde URL firmada (AWS virtual-hosted o path-style MinIO). */
export function extractS3KeyFromUrl(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (!/^https?:\/\//i.test(raw)) {
    return raw.replace(/^\/+/, "");
  }
  try {
    const u = new URL(raw);
    return decodeURIComponent(u.pathname || "").replace(/^\/+/, "").split("?")[0];
  } catch {
    return raw.split("?")[0].replace(/^\/+/, "");
  }
}

/** Key almacenada en BD o derivada de una URL (retrocompat). */
export function resolveStorageKey(keyOrUrl) {
  const raw = String(keyOrUrl || "").trim();
  if (!raw) return "";
  if (!/^https?:\/\//i.test(raw)) return raw;
  return extractS3KeyFromUrl(raw);
}

/** URLs listas para mostrar (catálogo o inventario). */
export function getProductImageUrls(producto) {
  if (!producto) return [];
  const fromArray = (producto.imagenes || [])
    .map((item) => String(item?.url || item?.imagenUrl || "").trim())
    .filter(Boolean);
  if (fromArray.length > 0) return fromArray;
  const legacy = String(producto.imagenUrl || "").trim();
  return legacy ? [legacy] : [];
}

/** Estado local del formulario / normalización cliente. */
export function normalizeProductoImagenes(p) {
  const raw = Array.isArray(p?.imagenes) ? p.imagenes : [];
  const fromArray = raw
    .map((item) => {
      const key =
        resolveStorageKey(item?.key || item?.imagenKey) ||
        resolveStorageKey(item?.url || item?.imagenUrl);
      const url = String(item?.url || item?.imagenUrl || "").trim();
      return key || url ? { key, url } : null;
    })
    .filter(Boolean);
  if (fromArray.length > 0) return fromArray;
  const key = resolveStorageKey(p?.imagenKey) || resolveStorageKey(p?.imagenUrl);
  const url = String(p?.imagenUrl || "").trim();
  return key || url ? [{ key, url }] : [];
}

export function buildImagenesPayload(imagenes) {
  return (imagenes || [])
    .map((item, orden) => ({
      key: resolveStorageKey(item?.key || item?.url),
      orden,
    }))
    .filter((i) => i.key);
}

export const MAX_PRODUCT_IMAGES = 10;
